import * as types from './types'
import storage from '@/plugins/storage'
const defaultStatus = {
  techArrived: false, // whenever the tech navigates to the Scan page (first time)
  techReviewedConfig: false, // when the tech clicks on the Configuration tab within Calibration accordion.
  techWorkingReport: false, // whenever the tech is in the Scan Report
  quickscanFirstPair: false, // quick scan device pairing
  quickscanComplete: false, // quick scan complete (set in calibration panel)
  quickscanResult: 0, // pass/fail (set by the master tech in calibration panel)
  quickscanNotes: '', // quick scan notes (set by the master tech in calibration panel)
  preppedCalibration: false, // shop tech sets this (after setting up fixtures)
  scanFirstPair: false, // calibration device pairing
  scanProgress: 0, // set a progress bar
  scanComplete: false, // master tech sets the Complete status in drop down in scan page
  reportSent: false, // show download report button (after master tech hits the Send Final Report)
  prepInstructions: '',
  aimingSnap: ''
}
export default () => ({
  calibration: null,
  cleanStatus: JSON.parse(JSON.stringify(defaultStatus)),
  stepStatus: JSON.parse(storage.local.getItem(types.SESSION_STEPSTATUS)) || JSON.parse(JSON.stringify(defaultStatus)),
  aimingUrls: null,
  alignmentSpecs: null
})



// WEBPACK FOOTER //
// ./src/store/modules/calibration/state.js